/* Creative Cot - in-page CTA smooth scroll.
   Section wrapper ids in a JSON template look like
   "shopify-section-template--<dynamic>__main-product", so we match by the
   stable "__<key>" suffix instead of a hardcoded id (works on staging + live). */
(function () {
  function scrollToMatch(substr) {
    var el = document.querySelector('[id*="' + substr + '"]');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (e) {
      // Primary CTA buttons -> scroll to the buy box.
      var cta = e.target.closest('a.cc-btn--cta');
      if (cta) {
        if (scrollToMatch('__main-product')) e.preventDefault();
        return;
      }
      // USP ghost button "Подивитися 5 режимів" -> scroll to the modes section.
      var ghost = e.target.closest('.cc-usp a.cc-btn--ghost');
      if (ghost) {
        if (scrollToMatch('__cc_modes')) e.preventDefault();
      }
    },
    false
  );
})();
